import React from 'react';
import './index.css';
import { HashRouter } from 'react-router-dom';
import App1 from './apps/App1';
import WordPressApp from './apps/WordPressApp';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import Theme from './Themes/main.theme';
import { buildShadowDomGivenRoot } from './lib/utils';
import { SnackbarProvider } from 'notistack';
import { oneStyle } from './importAllStyles';
import UserService from './services/UserService';
import HttpService from './services/HttpService';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import ReactDOM from 'react-dom/client';
import AppAdmin from './apps/AppAdmin';
import RandomImageList from './components/wp-widgets/RandomImageList';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import MicrositeLocationApp from './apps/MicrositeLocationApp';
import MicrositeProfessionalApp from './apps/MicrositeProfessionalApp';
import LoginWP from './components/wp-widgets/LoginWP';
import SmartAllAvailableApplications from './pages/Visitor/applications/_smart/SmartAllAvailableApplications';
import BreadcrumbContext from './components/context/BreadcrumbContext';

// const divToRenderOnDev = document.getElementById('divToRenderOnDev');
// const renderdev = document.getElementById('divToRenderOnDev');
const containerFirstRoot = document.querySelector('#root1');
const thirdRoot = document.querySelector('#root3');
const _searchElement = document.querySelector('#_searchElement');
const adminRootElement = document.querySelector('#adminRoot');
const loginWp = document.querySelector('#loginWp');

const allApplication = document.querySelector('#allApplication');

const searchLocationResults = document.querySelector('#searchLocationResults');
const professionalsSearch = document.querySelector('#professionalsSearch');

const adminRoot =
  adminRootElement && ReactDOM.createRoot(adminRootElement as HTMLElement);

let adminApp: () => void;
let renderRoot1: any;
let renderRoot3: any;
let renderSearch;
let renderLoginWP: any;
let renderSearchLocationResults: any;
let renderProfessionalsSearch: any;
let renderAllApplication: any;

if (adminRoot) {
  adminApp = () => {
    adminRoot.render(
      <React.StrictMode>
        <HashRouter>
          <SnackbarProvider maxSnack={3}>
            <ThemeProvider theme={Theme}>
              <>
                <AppAdmin />
              </>
            </ThemeProvider>
          </SnackbarProvider>
        </HashRouter>
      </React.StrictMode>
    );
  };
}

if (containerFirstRoot) {
  const { renderInShadowRoot: firstRenderInShadowRoot, cache: firstCache } =
    buildShadowDomGivenRoot(containerFirstRoot);
  renderRoot1 = () =>
    firstRenderInShadowRoot.render(
      <React.StrictMode>
        <CacheProvider value={firstCache}>
          <HashRouter>
            <ThemeProvider theme={Theme}>
              <div>
                <style>{oneStyle}</style>
                <App1 />
              </div>
            </ThemeProvider>
          </HashRouter>
        </CacheProvider>
      </React.StrictMode>
    );
}

if (thirdRoot) {
  const { renderInShadowRoot: thirdRenderInShadowRoot, cache: thirdCache } =
    buildShadowDomGivenRoot(thirdRoot);
  renderRoot3 = () =>
    thirdRenderInShadowRoot.render(
      <React.StrictMode>
        <CacheProvider value={thirdCache}>
          <SnackbarProvider maxSnack={3}>
            <ThemeProvider theme={Theme}>
              <I18nextProvider i18n={i18n}>
                <HashRouter>
                  <style>{oneStyle}</style>
                  <ScrollToTop />
                  <BreadcrumbContext.BreadcrumbProvider>
                    <WordPressApp />
                  </BreadcrumbContext.BreadcrumbProvider>
                </HashRouter>
              </I18nextProvider>
            </ThemeProvider>
          </SnackbarProvider>
        </CacheProvider>
      </React.StrictMode>
    );
}

if (searchLocationResults) {
  const {
    renderInShadowRoot: locationsRenderInShadowRoot,
    cache: searchCache,
  } = buildShadowDomGivenRoot(searchLocationResults);
  renderSearchLocationResults = () =>
    locationsRenderInShadowRoot.render(
      <React.StrictMode>
        <CacheProvider value={searchCache}>
          <SnackbarProvider maxSnack={3}>
            <ThemeProvider theme={Theme}>
              <I18nextProvider i18n={i18n}>
                <HashRouter>
                  <style>{oneStyle}</style>
                  <ScrollToTop />
                  <MicrositeLocationApp />
                </HashRouter>
              </I18nextProvider>
            </ThemeProvider>
          </SnackbarProvider>
        </CacheProvider>
      </React.StrictMode>
    );
}

if (professionalsSearch) {
  const {
    renderInShadowRoot: professionalRenderInShadowRoot,
    cache: professionalCache,
  } = buildShadowDomGivenRoot(professionalsSearch);
  renderProfessionalsSearch = () =>
    professionalRenderInShadowRoot.render(
      <React.StrictMode>
        <CacheProvider value={professionalCache}>
          <SnackbarProvider maxSnack={3}>
            <ThemeProvider theme={Theme}>
              <I18nextProvider i18n={i18n}>
                <HashRouter>
                  <style>{oneStyle}</style>
                  <ScrollToTop />
                  <MicrositeProfessionalApp />
                </HashRouter>
              </I18nextProvider>
            </ThemeProvider>
          </SnackbarProvider>
        </CacheProvider>
      </React.StrictMode>
    );
}

if (_searchElement) {
  const { renderInShadowRoot: searchRenderInShadowRoot, cache: searchCache } =
    buildShadowDomGivenRoot(_searchElement);
  renderSearch = () =>
    searchRenderInShadowRoot.render(
      <CacheProvider value={searchCache}>
        <ThemeProvider theme={Theme}>
          <I18nextProvider i18n={i18n}>
            <HashRouter>
              <RandomImageList />
            </HashRouter>
          </I18nextProvider>
        </ThemeProvider>
      </CacheProvider>
    );
}

if (loginWp) {
  const { renderInShadowRoot: searchRenderInShadowRoot, cache: loginWPCache } =
    buildShadowDomGivenRoot(loginWp);
  renderLoginWP = () =>
    searchRenderInShadowRoot.render(
      <CacheProvider value={loginWPCache}>
        <ThemeProvider theme={Theme}>
          <HashRouter>
            <I18nextProvider i18n={i18n}>
              <LoginWP />
            </I18nextProvider>
          </HashRouter>
        </ThemeProvider>
      </CacheProvider>
    );
}

if (allApplication) {
  const { renderInShadowRoot: newAppRenderInShadowRoot, cache: newAppCache } =
    buildShadowDomGivenRoot(allApplication);
  renderAllApplication = () =>
    newAppRenderInShadowRoot.render(
      <CacheProvider value={newAppCache}>
        <ThemeProvider theme={Theme}>
          <HashRouter>
            <SnackbarProvider maxSnack={3}>
              <I18nextProvider i18n={i18n}>
                <SmartAllAvailableApplications redirectsOutsideShadow />
              </I18nextProvider>
            </SnackbarProvider>
          </HashRouter>
        </ThemeProvider>
      </CacheProvider>
    );
}
renderSearch && renderSearch();

UserService
  .initKeycloak(renderRoot1)
  .then(() => {

    renderRoot1 && renderRoot1();
    // renderRoot2 && renderRoot2()
    HttpService.configure();
    renderRoot3 && renderRoot3();
    adminApp && adminApp();
    renderLoginWP && renderLoginWP();
    renderAllApplication && renderAllApplication();

    renderProfessionalsSearch && renderProfessionalsSearch();
    renderSearchLocationResults && renderSearchLocationResults();
  })
  .catch((err) => {
    console.error(err);
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
